import script from "./instrument.vue?vue&type=script&setup=true&lang=js"
export * from "./instrument.vue?vue&type=script&setup=true&lang=js"

import "./instrument.vue?vue&type=style&index=0&id=58e8568a&scoped=true&lang=less"

import exportComponent from "/data/opt/jenkins/workspace/prod/建博会大药房/dms-web-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58e8568a"]])

export default __exports__